// define o tipo da action
export const SET_AREAS = "SET_AREAS";
export const SET_SELECTED_AREA = "SET_SELECTED_AREA";

// action para salvar todas as áreas
export const setAreas = (areas) => ({
  type: SET_AREAS,
  payload: areas,
});

// action para salvar a área selecionada (se quiser abrir detalhes depois)
export const setSelectedArea = (area) => ({
  type: SET_SELECTED_AREA,
  payload: area,
});
